<template>
  <div>
    <b-alert :show="nextInvoiceSum < 0" variant="danger" class="">
      <p>
        <strong>Hei!</strong> Du har en gjeld som overgår det fakturerte
        beløpet, når du har innløste verdibevis til en verdi som overgår
        {{ -nextInvoiceSum.toFixed(2) }} kr vil faktura genereres. For mer info
        vennnligst ta kontakt med oss.
      </p>
    </b-alert>
    <b-table
      stacked="sm"
      hover
      :fields="fields"
      :items="invoiceList"
      v-if="invoiceList.length"
    >
      <template slot="total" slot-scope="data">
        {{ parseInt(data.value).toFixed(2) }} kr
      </template>

      <template #head(verdibevis)>
        Verdibevis
        <i
            v-b-tooltip.hover
            title="Verdibevisnummer som har blitt løst inn"
            class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template #head(navn)>
        Navn
        <i
            v-b-tooltip.hover
            title="Navn på opplevelsen som har blitt løst inn"
            class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template #head(total)>
          Total
          <i
            v-b-tooltip.hover
            title="Verdi per innløst opplevelse. Utsalgspris - provisjon(eks. mva)."
            class="fa fa-info-circle hoverable"
          ></i>
      </template>

      <template #head(dato)>
        Dato
        <i
            v-b-tooltip.hover
            title="Dato for når verdibeviset har blitt løst inn"
            class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_total">
        Total
        <i
          v-b-tooltip.hover
          title="Verdi per innløst opplevelse. Utsalgspris - provisjon(eks. mva)."
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_verdibevis">
        Verdibevis
        <i
          v-b-tooltip.hover
          title="Verdibevisnummer som har blitt løst inn"
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_navn">
        Navn
        <i
          v-b-tooltip.hover
          title="Navn på opplevelsen som har blitt løst inn"
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_dato">
        Dato
        <i
          v-b-tooltip.hover
          title="Dato for når verdibeviset har blitt løst inn"
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template #cell(total)="data">
        {{ parseInt(data.value).toFixed(2) }} kr
      </template>

      <template #cell(dato)="data">
        {{ formatDate(data.value) }}
      </template>
    </b-table>
    <b-alert
      :show="invoiceList.length === 0"
      variant="dark"
      class="text-center"
    >
      <strong>Listen er tom!</strong> Løs inn verdibevis for å motta oppgjør
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  format, //
  subDays,
  parseISO,
  isBefore,
} from "date-fns";
import { nb } from "date-fns/locale";

export default {
  data() {
    return {
      fields: ["verdibevis", "navn", "total", "dato"],
    };
  },
  computed: {
    ...mapGetters({
      invoiceList: "invoices/nextInvoiceTable",
      nextInvoiceSum: "invoices/nextInvoiceSum",
    }),
  },
  methods: {
    formatInvoiceDate(date) {
      const invoiceDate = parseISO(date);
      if (isBefore(invoiceDate, new Date("2016-09-30 23:59:59"))) {
        return this.formatDate(invoiceDate);
      }
      return format(subDays(invoiceDate, 1), "MMMM yyyy", { locale: nb });
    },
  },
};
</script>
